import { useFrame } from '@react-three/fiber'
import {
    OrbitControls
} from '@react-three/drei'
import { useRef } from 'react'
import * as THREE from 'three'
import { Perf } from 'r3f-perf'
import Lights from './Lights'
import Level from './Level'
import {Physics} from '@react-three/rapier'
import Player from './Player'
import useGame from './stores/useGame'
import Effects from './Effects'

export default function Experience() {
    const blocksCount = useGame((state) => { return state.blocksCount })
    const blocksSeed = useGame((state) => { return state.blocksSeed })
    // console.log(blocksCount)

    const cube = useRef()

    return <>
        <color attach="background" args={['#252731']} />
        <Perf position="top-left"/> 
        <OrbitControls makeDefault />
        <Physics>
            <Lights />
            <Level count={blocksCount} seed={blocksSeed} />
            <Player />
        </Physics>
        <Effects />



    </>
}